<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { tableData } from "./data";
import Heading from '../../layouts/heading.vue';
import api from "../../../api";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Practices",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Heading },
  data() {
    return {
      practices: [],
      page: {
        title: "Practices",
        lastUpdated: false,
        addNewBtn: true,
        addNewModalTitle: 'Create New Practice',
        formData: {},
        schema: {
          dynamo: {
            type: 'text',
            label: 'ODS Code',
            placeholder: 'Enter ODS Code',
            required: true,
            info: true,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          name: {
            type: 'text',
            label: 'Name',
            placeholder: 'Enter Name',
            required: true,
            info: true,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          url: {
            type: 'text',
            label: 'URL',
            placeholder: 'Enter URL',
            required: true,
            info: true,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          postcode: {
            type: 'text',
            label: 'Postcode',
            placeholder: 'Enter Postcode',
            required: false,
            info: true,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          pcn: {
              type: 'select',
              label: 'PCN',
              options: [],
              placeholder: '',
              required: true,
              info: false,
              character_count: 0
          }
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      },      
      tableData: tableData,
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "dynamo", sortable: true, label: 'ODS Code' },
        { key: "name", sortable: true, label: 'Practice Name' },
        { key: "postcode", sortable: true, label: 'Postcode' },
        { key: "pcnname", sortable: true, label: 'PCN Name' },
        { key: "stpname", sortable: true, label: 'STP Name' },
        { key: "actions", sortable: false }
      ],
      editPractice: {
        name: '',
        postcode: '',
        url: '',
        pcnId: ''
      }
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.practices.length;
    },
    // currentUser() {
    //   return JSON.parse(localStorage.getItem('currentUser'));
    // },
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async create(val) {
      if(val.name && val.dynamo && val.url && val.pcn) {
        console.log('val', val)
      }
      else {
        Swal.fire("Invalid Input!", "ODS Code, Practice Name and URL are mandatory.", "error");
      }
      await this.createPractice(this.currentUser.id, val)
      this.getPractices();
    },
    getPcns() {
      api.get('/api/pcns')
      .then(response => {
        this.page.schema.pcn.options = response.data;

        // this.page.table.rows = response.data
        // this.page.formData.permissions = response.data
        // delete this.page.table.rows.timestamp
        // delete this.page.formData.permissions.timestamp
      })
      .catch(e => {
        console.log(e)
      })
    },
    getPractices() {
      api.get('/api/practices')
      .then(response => {
        this.practices = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })   
    },
    editModal(val) {
      this.$bvModal.show(`modal-edit${val.id}`)
      this.editPractice = val
      this.editPractice.url = val.additionalProp1.url
      this.editPractice.postcode = val.additionalProp1.postcode
    },
    async updatePractice(val) {
      try {
        await api.patch(`/api/practices/${val}`, {
          name: this.editPractice.name,
          additionalProp1: {
            dynamo: this.editPractice.additionalProp1.dynamo,
            postcode: this.editPractice.postcode,
            url: this.editPractice.url
          },
          pcnId: this.editPractice.pcnId
        })
        Swal.fire('Practice Updated Successfully!', 'Practice Updated Successfully!', 'success')
        this.getPractices()
      }
      catch (e) {
        Swal.fire('Practice Updation Failed!', 'Practice Updation Failed!', 'error')
        console.log(e)
      }
      this.$bvModal.hide(`modal-edit${val}`)
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getPractices();
    this.getPcns();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page" @created="create"></Heading>

    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div class="d-flex">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive table-striped mb-0">
            <b-table
              :items="practices"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
            <template v-slot:cell(dynamo)="row">
              <div class="font-size-16">
                {{row.item.additionalProp1.dynamo}}
              </div>
            </template>
            <template v-slot:cell(postcode)="row">
              <div class="font-size-16">
                {{row.item.additionalProp1.postcode}}
              </div>
            </template>
            <template v-slot:cell(pcnname)="row">
              <div class="font-size-16">
                {{row.item.additionalProp1.pcnname}}
              </div>
            </template>
            <template v-slot:cell(stpname)="row">
              <div class="font-size-16">
                {{row.item.additionalProp1.stpname}}
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <button v-b-modal="'modal-edit' + row.item.id"
              class="btn btn-light btn-sm float-right font-size-14"
              @click="editModal(row.item)">
                Edit
              </button>
              <button v-b-modal="'modal' + row.item.id"
              class="btn btn-light btn-sm float-right font-size-14 mr-3">
                View
              </button>
              <!-- <button v-if="!row.item.isAdmin" v-b-modal="'modal' + row.item.id" class="btn btn-light btn-rounded">
                Add Practice
                <i class="mdi mdi-plus-circle ml-2"></i>
              </button> -->
              <!-- <b-modal
                :id="'editmodal' + row.item.id"
                centered
                title="Edit User"
                title-class="font-18"
                hide-footer
              >
                <JsonForm v-if="!selectPracticeFlag" :schema="page.editSchema" :formData="editFormData" :page="page"></JsonForm>

                <div v-else class="overflow-auto mb-4">
                  <a class="font-weight-bold pe-auto" v-on:click="selectAllPractices()">Select All</a>
                  <div style="height: 300px">
                    <ul v-for="item of practices" v-bind:key="item.id" class="list-group list-group-flush">
                      <li class="list-group-item border-top pl-0" 
                      :class="selectedPractices.includes(item.id) ? 'text-primary': ''"
                      v-on:click=" selectPractice(item)"
                      >
                      <img v-if="selectedPractices.includes(item.id)" 
                      class="align-self-center mr-3"
                      src="@/assets/images/active-tick.svg" alt="">
                      <img v-else class="align-self-center mr-3"
                      src="@/assets/images/check-box.svg" alt="">
                      {{item.name}}</li>
                    </ul>
                  </div>
                </div>

                <b-button variant="light" v-on:click="selectPracticeFlag = !selectPracticeFlag;">
                <span v-if="!selectPracticeFlag">Edit Practice</span>
                <span v-if="selectPracticeFlag">Go back</span>
                </b-button>
                <b-button v-on:click="update(editFormData); $bvModal.hide('editmodal' + row.item.id);" class="float-right" variant="primary">Update</b-button>
              </b-modal> -->
              <b-modal
                :id="'modal-edit' + row.item.id"
                centered
                title="Practice Profile"
                title-class="font-18"
                hide-footer
              >
              <div class="row">
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >ODS Code</label>
                  <input type="text" disabled class="form-control" :value="row.item.additionalProp1.dynamo">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >Name</label>
                  <input type="text" class="form-control" v-model="editPractice.name">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >URL</label>
                  <input type="text" class="form-control" v-model="editPractice.url">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >Postcode</label>
                  <input type="text" class="form-control" v-model="editPractice.postcode">
                </div>
                <div class="col-12">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >PCN</label>
                  <select class="form-control" name="pcn" id="pcn" v-model="editPractice.pcnId">
                    <option v-for="pcn in page.schema.pcn.options" :key="pcn.id" :value="pcn.id"
                    :selected="editPractice.pcnId == pcn.id"
                    >{{pcn.name}}</option>
                  </select>
                </div>
                <div class="col-12">
                  <button class="btn btn-primary mt-3 float-right" @click="updatePractice(row.item.id)">Update</button>
                </div>
              </div>
            </b-modal>
              <b-modal
                :id="'modal' + row.item.id"
                centered
                title="Practice Profile"
                title-class="font-18"
                hide-footer
              >
              <div class="row">
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >ODS Code</label>
                  <input type="text" disabled class="form-control" :value="row.item.additionalProp1.dynamo">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >Name</label>
                  <input type="text" disabled class="form-control" :value="row.item.name">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >URL</label>
                  <input type="text" disabled class="form-control" :value="row.item.additionalProp1.url">
                </div>
                <div class="col-6">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >Postcode</label>
                  <input type="text" disabled class="form-control" :value="row.item.additionalProp1.postcode">
                </div>
                <div class="col-12">
                  <label
                  class="pr-2 my-2 align-self-sm-center font-theme-black-color font-size-14 font-weight-bold"
                  >PCN</label>
                  <input type="text" disabled class="form-control" :value="page.schema.pcn.options.find(element => element.id == row.item.pcnId) ? page.schema.pcn.options.find(element => element.id == row.item.pcnId).name : 'N/A'">
                </div>
              </div>
            </b-modal>
            </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.table td {
  border-top: 1px solid #dadce3 !important;
}
.table th {
  border-top: 1px solid #dadce3 !important;
}
</style>